<p class="product-info-text">
  <span class="nes-font-bold">{{ "RECEIPT.MANUAL_ORDER.LABEL" | translate }}</span>
  {{ "RECEIPT.MANUAL_ORDER.TEXT" | translate }}
  <nes-link (nesOnClick)="goToDownloadForm()">{{ "RECEIPT.MANUAL_ORDER.BUTTON" | translate }}</nes-link>
</p>
